import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { adminMainUrl } from "../../../../Config";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getAllGroupMasterData,
  getAllMasterAccountParentGroupIdAndName,
  getMasterAccountGroupTypeIdAndName,
  getMasterAccountSubGroupTypeIdAndName,
} from "../../../../Redux/action/MasterAction";
import EditGroupMaster from "./EditGroupMaster";
import { generateCode } from "../../../../helper/autoGenId";
import AccountPagination from "../../../Masters/AccountMaster/GroupMaster/AccountPagination";

const GroupMaster = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const {
    MasterAccountParentGroupName,
    loadingMasterAccountParentGroupName,

    loadingMasterAccountGroupTypeName,
    MasterAccountGroupTypeName,

    loadingMasterAccountSubGroupTypeName,
    MasterAccountSubGroupTypeName,

    GroupMaster,
    GroupMasterCurrentPage,
    GroupMasterTotalPage,
    GroupMasterTotalData,
  } = useSelector((state) => state?.MasterReducer);

  const [groupFormData, setGroupFormData] = useState({
    group_code: "",
    name: "",
    parent_group: "",
    parent_group_id: "",
    group_type: "",
    group_type_id: "",
    sub_group_type: "",
    sub_group_type_id: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState("");
  const [selectedGroupTypeId, setSelectedGroupTypeId] = useState("");
  const [editshow, setEditShow] = useState(false);

  const [state_id, setState_id] = useState(null);
  const [selectedGroupMaster, setSelectedGroupMaster] = useState();

  const [MaterParentName, setMaterParentName] = useState("");
  const [MasterGroupTypeName, setMasterGroupTypeName] = useState("");

  const dataPerPage = 10;
  const [reload, setReload] = useState(false);

  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  // const [editshow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const refresh = () => {
    if (token && user_id) {
      dispatch(
        getAllGroupMasterData(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search"),
        ),
      );
    }
  };

  const statusChange = async (id) => {
    // setSpinnerLoader(true);
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/group-master-status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        refresh();
        // setSpinnerLoader(false);
        // handleSuccess(); // Call the success handler
        toast.success(data?.msg);
      } else {
        // setSpinnerLoader(false);
        toast.error(data?.msg);
      }
    } catch (error) {
      // setSpinnerLoader(false);
      console.error("Network error:", error);
    }
  };

  const handleChange = (id) => {
    statusChange(id);
  };

  const handleEditShow = (id) => {
    if (id) {
      setEditShow(true);
      const data = GroupMaster.find((item) => item.id === id);
      setSelectedGroupMaster(data);
      setState_id(id);
    } else {
      toast.error("Id not found. Please retry.");
    }
  };
  const handleSuccess = () => {
    setReload((prev) => !prev);
  };

  const [dataSourcer, setDataSourcer] = useState([
    {
      key: 2,
      group_code: "GRP-101",
      name: "GRP-101",
      parent_group: "Logistics",
      group_type: "Freight",
    },
    {
      key: 3,
      group_code: "GRP-102",
      name: "GRP-102",
      parent_group: "Operations",
      group_type: "Cargo",
    },
    {
      key: 4,
      group_code: "GRP-103",
      name: "GRP-103",
      parent_group: "Operations",
      group_type: "Warehouse",
    },
    {
      key: 5,
      group_code: "GRP-104",
      name: "GRP-104",
      parent_group: "Transport",
      group_type: "Cargo",
    },
    {
      key: 6,
      group_code: "GRP-105",
      name: "GRP-105",
      parent_group: "Transport",
      group_type: "Fleet",
    },
    {
      key: 7,
      group_code: "GRP-106",
      name: "GRP-106",
      parent_group: "Supply Chain",
      group_type: "Distribution",
    },
    {
      key: 8,
      group_code: "GRP-107",
      name: "GRP-107",
      parent_group: "Supply Chain",
      group_type: "Cargo",
    },
    {
      key: 9,
      group_code: "GRP-108",
      name: "GRP-108",
      parent_group: "Support",
      group_type: "Admin",
    },
  ]);

  const groupTestData = [
    {
      key: 2,
      group_code: "GRP-101",
      name: "GRP-101",
      parent_group: "Logistics",
      group_type: "Freight",
      status: true,
    },
    {
      key: 3,
      group_code: "GRP-102",
      name: "GRP-102",
      parent_group: "Operations",
      group_type: "Cargo",
      status: true,
    },
    {
      key: 4,
      group_code: "GRP-103",
      name: "GRP-103",
      parent_group: "Operations",
      group_type: "Warehouse",
    },
    {
      key: 5,
      group_code: "GRP-104",
      name: "GRP-104",
      parent_group: "Transport",
      group_type: "Cargo",
    },
    {
      key: 6,
      group_code: "GRP-105",
      name: "GRP-105",
      parent_group: "Transport",
      group_type: "Fleet",
    },
    {
      key: 7,
      group_code: "GRP-106",
      name: "GRP-106",
      parent_group: "Supply Chain",
      group_type: "Distribution",
    },
    {
      key: 8,
      group_code: "GRP-107",
      name: "GRP-107",
      parent_group: "Supply Chain",
      group_type: "Cargo",
    },
    {
      key: 9,
      group_code: "GRP-108",
      name: "GRP-108",
      parent_group: "Support",
      group_type: "Admin",
    },
  ];

  const filteredGroupTypes = MasterAccountGroupTypeName.filter(
    (x) => x.parent_group_id == selectedParentId,
  );

  const filteredSubGroups = MasterAccountSubGroupTypeName.filter(
    (x) => x.group_type_id == selectedGroupTypeId,
  );

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setGroupFormData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const submitGroupForm = async () => {
    console.log("groupFormData", groupFormData);
    setIsSubmitting(true);
    try {
      const response = await fetch(`${adminMainUrl}/api/account/group-master`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          user_id: Cookies.get("flexichain_user_id"),
        },
        body: JSON.stringify(groupFormData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg);
        refresh();
        setGroupFormData({
          group_code: "",
          name: "",
          parent_group: "",
          parent_group_id: "",
          group_type: "",
          group_type_id: "",
          sub_group_type: "",
          sub_group_type_id: "",
        });
      } else {
        toast.error(data?.msg);
        // Handle errors from the server
        console.error("Error creating Group master Type:", data.message);
      }
    } catch (error) {
      console.error("Network error:", error);
    } finally {
      setIsSubmitting(false); // Stop the spinner
    }
  };

  const clearGroupForm = () => {
    setGroupFormData({
      group_code: "",
      name: "",
      parent_group: "",
      group_type: "",
      sub_group_type: "",
      active: "",
    });
  };

  const handleUpdate = (row) => {
    // console.log("Update:", row);
    // open modal / form
  };

  const handleDelete = (row) => {
    // console.log("Delete:", row);
    setDataSourcer((prev) => prev.filter((item) => item.key !== row.key));
  };

  const handleDeactivate = (row) => {
    setDataSourcer((prev) =>
      prev.map((item) =>
        item.key === row.key ? { ...item, status: "Inactive" } : item,
      ),
    );
  };

  const handleActivate = (row) => {
    setDataSourcer((prev) =>
      prev.map((item) =>
        item.key === row.key ? { ...item, status: "Active" } : item,
      ),
    );
  };

  const columns = [
    {
      title: "Group Code",
      dataIndex: "group_code",
      key: "group_code",
    },
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
    },
    { title: "Parent_ Group", dataIndex: "parent_group", key: "parent_group" },
    {
      title: "Group Type",
      dataIndex: "group_type",
      key: "group_type",
    },
    { title: "Status", dataIndex: "Status", key: "Status" },
    { title: "Action", dataIndex: "action", key: "action" },

    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, record) => (
    //     <div className="d-flex gap-2">
    //       <button
    //         className="btn btn-sm btn-primary"
    //         onClick={() => handleUpdate(record)}
    //       >
    //         Update
    //       </button>

    //       <button
    //         className="btn btn-sm btn-danger"
    //         onClick={() => handleDelete(record)}
    //       >
    //         Delete
    //       </button>

    //       {record.status === "Active" ? (
    //         <button
    //           className="btn btn-sm btn-warning"
    //           onClick={() => handleDeactivate(record)}
    //         >
    //           Deactivate
    //         </button>
    //       ) : (
    //         <button
    //           className="btn btn-sm btn-success"
    //           onClick={() => handleActivate(record)}
    //         >
    //           Activate
    //         </button>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  const dataSource = GroupMaster?.map((value, i) => ({
    key: i, // Add a unique key for each row
    SNo: i + 1, // Changed to camelCase
    group_code: value?.code, // Ensure date formatting as neede
    name: value?.name, // Ensure date formatting as neede
    parent_group: value?.parent_group, // Ensure date formatting as neede
    group_type: value?.group_type, // Ensure date formatting as neede
    Status: (
      <>
        <span
          id={`flexSwitchCheckChecked-${i}`}
          title="Click to change status"
          onClick={() => handleChange(value.id)}
          className={`cursor-pointer ${
            value.status === true
              ? "badge badge-pill badge-status bg-success"
              : "badge badge-pill badge-status bg-danger"
          }  `}
        >
          {value.status === true ? "Active" : "Inactive"}
        </span>
      </>
    ),
    action: (
      <div className="dropdown table-action">
        <Link to="#" className="action-icon" data-bs-toggle="dropdown">
          <i className="fa fa-ellipsis-v"></i>
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
          <div
            className=" cursor-pointer"
            onClick={() => {
              handleEditShow(value?.id);
            }}
          >
            <i className="ti ti-edit text-blue"></i> Edit
          </div>
        </div>
      </div>
    ),
  }));

  useEffect(() => {
    if (token && user_id) {
      let invoice_id = generateCode();
      if (invoice_id) {
        setGroupFormData((pre) => ({
          ...pre,
          ["group_code"]: invoice_id,
        }));
      }
      dispatch(
        getAllGroupMasterData(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search"),
        ),
      );
      dispatch(getMasterAccountGroupTypeIdAndName(token, user_id));
      dispatch(getAllMasterAccountParentGroupIdAndName(token, user_id));
      dispatch(getMasterAccountSubGroupTypeIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id, location.search]);

  return (
    <>
      <div>
        <h5 className="fw-semibold mb-3">Group Master Form</h5>

        <div className="row">
          {/* Group Code */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Group Code <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="group_code"
              className="form-control bg-light"
              placeholder="Auto-generated"
              disabled
              value={groupFormData.group_code}
            />
          </div>

          {/* Group Name */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Group Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="name"
              className="form-control bg-light"
              placeholder="Enter Group Name"
              onChange={onValueChange}
              value={groupFormData.name}
              maxLength={100}
            />
          </div>

          {/* Parent Group */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Parent Group <span className="text-danger">*</span>
            </label>

            {/* <select
              onChange={onValueChange}
              value={groupFormData.parent_group}
              name="parent_group"
              className="form-select bg-light"
            >
              <option value="">Select parent group </option>
              {MasterAccountParentGroupName.map((item) => (
                <option value={item.name}>{item.name}</option>
              ))}
            </select> */}

            <select
              name="parent_group"
              className="form-select bg-light"
              value={groupFormData.parent_group_id} // FIXED
              onChange={(e) => {
                const selected = MasterAccountParentGroupName.find(
                  (x) => x.id == e.target.value,
                );

                setSelectedParentId(e.target.value);

                setGroupFormData((prev) => ({
                  ...prev,
                  parent_group_id: selected?.id, // for select highlight
                  parent_group: selected?.name, // for API
                  group_type_id: "",
                  group_type: "",
                  sub_group_type_id: "",
                  sub_group_type: "",
                }));
              }}
            >
              <option value="">Select Parent Group</option>
              {MasterAccountParentGroupName.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* Group Type */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Group Type <span className="text-danger">*</span>
            </label>
            {/* 
            <select
              onChange={onValueChange}
              value={groupFormData.group_type}
              name="group_type"
              className="form-select bg-light"
            >
              <option value="">Select group type</option>
              <option value="1">group type 1</option>
            </select> */}

            <select
              name="group_type"
              className="form-select bg-light"
              value={groupFormData.group_type_id} // FIXED
              onChange={(e) => {
                const selected = filteredGroupTypes.find(
                  (x) => x.id == e.target.value,
                );

                setSelectedGroupTypeId(e.target.value);

                setGroupFormData((prev) => ({
                  ...prev,
                  group_type_id: selected?.id,
                  group_type: selected?.name,
                  sub_group_type_id: "",
                  sub_group_type: "",
                }));
              }}
            >
              <option value="">Select Group Type</option>
              {filteredGroupTypes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* Sub Group Type */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Sub Group Type <span className="text-danger">*</span>
            </label>

            {/* <select
              onChange={onValueChange}
              value={groupFormData.sub_group_type}
              name="sub_group_type"
              className="form-select bg-light"
            >
              <option value="">Based on Group Type</option>
              <option value="sub 1">Type 1</option>
            </select> */}

            <select
              name="sub_group_type"
              className="form-select bg-light"
              value={groupFormData.sub_group_type_id} // FIXED
              onChange={(e) => {
                const selected = filteredSubGroups.find(
                  (x) => x.id == e.target.value,
                );

                setGroupFormData((prev) => ({
                  ...prev,
                  sub_group_type_id: selected?.id,
                  sub_group_type: selected?.name,
                }));
              }}
            >
              <option value="">Select Sub Group Type</option>
              {filteredSubGroups.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="d-flex gap-2 mt-3">
          <button
            onClick={() => submitGroupForm()}
            className="btn btn-primary px-4"
          >
            <i className="fas fa-save me-1"></i> Create Group
          </button>
        </div>
      </div>

      <hr />

      <div className="table-responsive custom-table">
        <Table
          className="table datanew dataTable no-footer"
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </div>

      <AccountPagination
        currentPage={GroupMasterCurrentPage}
        totalPages={GroupMasterTotalPage}
        onPageChange={(page) => {
          dispatch(getAllGroupMasterData(token, user_id, page));
        }}
      />

      <EditGroupMaster
        state_id={state_id}
        show={editshow}
        handleClose={handleEditClose}
        onSuccess={handleSuccess}
        token={token}
        user_id={user_id}
        refresh={refresh}
        selectedGroupMaster={selectedGroupMaster}

        // subGroupTypeData={subGroupTypeData}
      />
    </>
  );
};

export default GroupMaster;
